import { createSelector } from 'reselect';

import { namesOfAction, actions } from '@pages/names';
import menuOrder from '@utils/menuOrder';

import prop from 'lodash/fp/prop';
import noop from 'lodash/noop';
import get from 'lodash/get';
import config from '@config';

export const pagesTitles = {
  [actions.Home]: 'Todos los partidos',
  [actions.Snapshot]: 'Mi prode',
  [actions.Ranking]: 'Ranking general',
  [actions.MyProfile]: 'Perfil',
  [actions.RankingDetails]: 'Detalle de Torneo',
  [actions.Snapshots]: 'Pronóstico Ajeno',
  [actions.Scores]: 'Mis puntajes',
  [actions.Rules]: 'Reglas — puntajes',
};

const getPageAction = (dir) => (type) =>
  actions[menuOrder[menuOrder.indexOf(namesOfAction[type]) + dir]];

export const getNext = createSelector(prop('location.type'), (type) =>
  [actions.MyProfile, actions.RankingDetails].includes(type)
    ? noop()
    : getPageAction(1)(type)
);

export const getPrev = createSelector(prop('location.type'), (type) =>
  getPageAction(-1)(type)
);

export const isShareForecast = createSelector(
  prop('location.type'),
  (type) => type === actions.Snapshots
);

export const isScoresView = createSelector(
  prop('location.type'),
  (type) => type === actions.Scores
);

export const isPublicScoresView = createSelector(
  [isScoresView, prop('location.payload.userId')],
  (scoresView, userId) => scoresView && !!userId
);

export const isSnapshotView = createSelector(
  [prop('location.type'), isShareForecast, prop('subpage')],
  (type, isShare, subpage) =>
    type === actions.Snapshot || isShare /*&& subpage === 'results'*/
);

export const isEditingForecast = createSelector(
  prop('location.type'),
  (type) => type === actions.Home
);

export const avoidLandingPage = createSelector(prop('location.type'), (type) =>
  [
    actions.Snapshots,
    actions.Scores,
    actions.RankingDetails,
    actions.Ranking,
  ].includes(type)
);

export const getShareLink = createSelector(
  [prop('location'), prop('user'), prop('rankingDetails')],
  (location, user, rankingDetails) => {
    let base = `${config.host}${config.basePath}`;
    let from = `${get(pagesTitles, location.type, '')}`;
    let defaultURL = `${base}${get(location, 'pathname', '')}`;
    let msg =
      'Prode 2026. Sumate al juego de Página/12 para la Copa del Mundo 2026';

    let myForecast = {
      url: `${base}/snapshots/${get(user, '_id')}`,
      from,
      message:
        'Mi Mundial Ideal en el Prode 2026 - Página/12 - Copa Mundial 2026',
    };

    let defaultShare = { url: base, message: msg, from };

    const shares = {
      [actions.Home]: get(user, '_id') ? myForecast : defaultShare,
      [actions.Snapshot]: myForecast,
      [actions.Ranking]: {
        url: defaultURL,
        from,
        message:
          'Ranking General de Participantes del Prode 2026 - Página/12 - Copa Mundial 2026',
      },
      [actions.RankingDetails]: {
        url: defaultURL,
        from,
        message: `${get(
          rankingDetails,
          'name'
        )}, un torneo del Prode 2026 - Página/12 - Copa Mundial 2026`,
      },
    };

    return shares[location.type] || defaultShare;
  }
);
